<template>
  <div>
    <Head :title="__(title)" />
    <div class="max-w-2xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pb-8 pr-6 w-full"
            :label="__('Name')"
          />
          <div class="pb-8 pr-6 w-full">
            <label class="form-label">{{ __('Description') }}</label>
            <textarea
              v-model="form.description"
              class="form-input w-full"
              rows="3"
            />
            <div v-if="form.errors.description" class="form-error">{{ form.errors.description }}</div>
          </div>
          <div class="pb-8 pr-6 w-full flex items-center gap-3">
            <label class="form-label mb-0">{{ __('Active') }}</label>
            <input v-model="form.active" type="checkbox" class="w-5 h-5 cursor-pointer" />
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            {{ __('Create Product') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  name: 'ServiceCreate',
  components: { Head, LoadingButton, TextInput },
  layout: Layout,
  props: { title: String },
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        description: '',
        active: true,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('services.store'))
    },
  },
}
</script>
